import  {LOAD_GVS,LOAD_GV,LOAD_MON, LOAD_MONS,LOAD_MON_MONFORM,LOAD_MONITORS_MONITORFORM,CHANGE_DISPLAY_LINECHART,SHOW_CHARTTYPE,SHOW_LINECHART,LOAD_STRAND_MEMORY_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,SHOW_MODAL_BA, HIDE_MODAL_BA,LOAD_SVSTRANDS_DYNA,SVSTRANDFORM,LOAD_GENE_UI_DATA_CSTEPFORM_BUS,LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,LOAD_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS,LOAD_CLASSIFIER_FORM,CREATE_STEP,DELETE_TASK,ADD_USER,REMOVE_USER,RESET_USER_FORM,UPDATE_USER_FORM,FETCH_MOVIES,FETCH_MOVIE,FETCH_USER,FETCH_USERS,GET_EP,GET_TASK,LIST_TASKS, COUNTER_ACTION, LOAD_CLASSIFIERSTEP_CSTEPFORM, LOAD_CLASSIFIERSTEP_CSTEPFORM_EP,LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS} from '../constants'
import _ from 'lodash'
import {SVRCFORM,SVPCFORM,SVPDFORM,SVFPDFORM,SVTPPFORM,SVFPPFORM,SVFRCFORM ,SVFPCFORM, SVFPIFORM, SVTPIFORM, SVMCIFORM, SVVPCFORM} from '../constants'
import {SJRCFORM,SJPCFORM,SJPDFORM,SJSJCFORM} from '../constants'
import {CRRCFORM,CRPCFORM,CRPDFORM,CRSJCFORM} from '../constants'


/*
import { change } from 'redux-form';
import { SVStringEp } from '../components/core/index';
import svgateChart from '../components/graphs/svgateChart';
*/
/*
const FETCH_MOVIES = 'movies/FETCH_MOVIES'
const FETCH_MOVIE = 'movies/FETCH_MOVIE'
const LIST_TASKS = 'tasks/LIST_TASKS'
const GET_TASK = 'task/GET_TASK'

const GET_EP = 'endpoint/GET_EP'
*/
const portTypes=[{
  "key": "CL_Number",
  "value": "number"
}, {
  "key": "CL_String",
  "value": "string"
 }, {
  "key": "CL_FLOW_OBJECT_SV",
  "value": "FLOW_OBJECT_SV"  

}, {
  "key": "CL_Date",
  "value": "date"
 
}]

const svtypes= ['single', 'double', 'complex']
const locationTypes = [{
    name:'START',
    value:'START'
},{
    name:'CARRIER',
    value:'CARRIER'
},{
    name:'END',
    value:'END'
}]

let svtasks = [{
  "id":1,
   "name":"pdfTask",
   "description":"Alll tasks",
   "configSchema":"<pdfTask></pdfTask>",
   "endpoints":[{
     "url":"execute1",
     "inputSchema":"",
     "outputSchema":""
   },{
     "url":"schedule1",
     "inputSchema":"",
     "outputSchema":""
   }]
 
 },{
   "id":2,
 
   "name":"emailTask",
   "description":"AEmaillll tasks",
   "configSchema":"<pdfTask></pdfTask>",
   "endpoints":[{
     "url":"execute2",
     "inputSchema":"",
     "outputSchema":""
   }]
 }]

//loadCstepform
const initialState ={
  gvformData:{

   
    "id": 41,
    "company": "Jelly",
    "svelkQueryType": "USER",
    "svendpoint": "svelkAwsErrors",
    "svnameMeta": "svmetadataMicroHnttToday_DashLayout",
    "name": "VOS",
    "position": 1,
  
    /*vmodel*/
    "adapter": "elk",
    "seriesAxisType": "datetime",
    /*svmodel..*/
        "layout": 3,
         "svEventsShow": false,
        "svFooter": "Sea",
        "svHeading": "SVErrors By Type",
        "svid": "svmhhrt_svc",
        "svnameChart": "svchartRingMicroToday_DashLayout",
        "svstartBiReportType": "SVBITYPE_SVCLOG",
        "svstartMeasure": "quantity",
        "svvis": "pie",
        "yName": "doc_count"
},
  gvs:{
    "company":"Marianne",
     vislets:[]

  },
  mon:{
    "name": "Alex B",
    "id": "Facebook1",
    "layout": "4X4",
    "widgets": [{
      "position": 1,
      "chart": {
        "svnameChart": "svchartRingMicroToday_DashLayout",
        "svid": "svmhhrt_svc",
        "layout": 3,
        "svvis": "pie",
        "svHeading": "SVErrors By Type",
        "svEventsShow": false,
        "svFooter": "Sea",
        "svstartMeasure": "quantity",
        "svstartBiReportType": "SVBITYPE_SVCLOG",
        "yName": "doc_count"
  
      },
      "metadata": {
        "svnameMeta": "svmetadataMicroHnttToday_DashLayout",
  
        "svendpoint": "svelkAwsErrors",
        "svrest": "REST",
        "svelkQueryType": "USER",
        "svServer": "http://localhost:3004",
        "svMethod": "POST",
        "svQueryGet": "",
        "svTodayDate": "2017-07-19",
        "svHeading": "SVErrorTypes Errors",
        "SVHNTT_DAILY": true,
        "svEndPointClientFilterType": "SVHNTT_DAILY"
  
      }
    }, {
  
  
      "position": 2,
      "chart": {
        "svnameChart": "svchartConElToday",
        "svid": "svceosr",
        "layout": 10,
        "svvis": "line",
        "svHeading": "Connectivity Errors",
        "svEventsShow": false,
        "svFooter": "Sea",
        "svstartMeasure": "doc_count",
        "svstartBiReportType": "SVBITYPE_SVCLOG",
        "yName": "doc_count"
  
      },
      "metadata": {
        "svnameMeta": "svmetadataConElToday",
  
        "svendpoint": "svelkAwsErrors",
        "svrest": "REST",
        "svelkQueryType": "USER",
        "svServer": "http://localhost:3004",
        "svMethod": "POST",
        "svQueryGet": "",
        "svTodayDate": "2017-07-19",
        "svHeading": "SVConnectivity Errors",
        "SVHNTT_DAILY": true,
        "svEndPointClientFilterType": "SVHNTT_DAILY"
  
      }
  
    }, {
  
  
      "position": 3,
      "chart": {
        "svnameChart": "svchartCouchElToday",
        "svid": "svciosr",
        "layout": 6,
        "svvis": "area",
        "svHeading": "Couchebase Interactionss",
        "svEventsShow": false,
        "svFooter": "Sea",
        "svstartMeasure": "doc_count",
        "svstartBiReportType": "SVBITYPE_SVCLOG",
        "yName": "doc_count"
  
      },
      "metadata": {
        "svnameMeta": "svmetadataCouchElToday",
  
        "svendpoint": "elkOsrChart",
        "svrest": "REST",
        "svelkQueryType": "USER",
        "svServer": "http://localhost:3004",
        "svMethod": "POST",
        "svQueryGet": "",
        "svTodayDate": "2017-07-19",
        "svHeading": "SVConnectivity Errors",
        "SVHNTT_DAILY": true,
        "svEndPointClientFilterType": "SVHNTT_DAILY"
  
      }
  
    }, {
  
  
      "position": 4,
      "chart": {
        "svnameChart": "svchartApiElToday",
        "svid": "svaiosr",
        "layout": 6,
        "svvis": "line",
        "svHeading": "API Errors",
        "svEventsShow": false,
        "svFooter": "Sea",
        "svstartMeasure": "doc_count",
        "svstartBiReportType": "SVBITYPE_SVCLOG",
        "yName": "doc_count"
  
      },
      "metadata": {
        "svnameMeta": "svmetadataApiElToday",
  
        "svendpoint": "elkOsrChart",
        "svrest": "REST",
        "svelkQueryType": "USER",
        "svServer": "http://localhost:3004",
        "svMethod": "POST",
        "svQueryGet": "",
        "svTodayDate": "2017-07-19",
        "svHeading": "ailed API Errorss",
        "SVHNTT_DAILY": true,
        "svEndPointClientFilterType": "SVHNTT_DAILY"
  
      }
  
  
    }],
    "email": "alex@yahoo.com"
  
  
  },
  mons:{
    "company":"Marianne",
     monitors:[]

  },
  svgateChartDyna:{
    SVCOMTYPE:'LINE',
    toSVCOMTYPE:'LINE',
    fromSVCOMTYPE:'LINE',
    fromStrandName:'STRAND_NO_NAME',
    fromStrandIdx:-4,
  
    svconfig :{
      "SVCOMTYPE":"LINE",
      "portConfig": {
          "stepPositionInParallelGate":"END",
          "portA": "VAR_SV",
          "portB": "VAR_SV",
          "outA": "END"
  
      },
      "endPoint": {
          "url": "http://localhost:3004/multiply",
          "configSchema": {
              "portA": 20,
              "portB": 30,
              "outA": -1
          },
          "in": {
  
              "portA": 40,
              "portB": 50,
              "outA": -1
  
  
  
  
          },
          "out": {
              "portA": 50,
              "portB": 300,
              "outA": -1
          }
  
      },
      "outConfig": {
          "portA": 10,
          "portB": 20,
          "outA": -1
      }
  },  

  },
  svgateChartContainerDyna:{
    "dna": {
        "addLeft_step": {
            "type": "app.CircularModel",
            "size": {
                "width": 5,
                "height": 3
            },
            "inPorts": ["in1", "in2"],
            "outPorts": ["out"],
            "svconfig": {
                "portConfig": {
                    "portA": "START",
                    "portB": "START",
                    "outA": "FLOW"
                },
                "endPoint": {
                    "url": "http://localhost:3004/add",
                    "configSchema": {
                        "portA": 10,
                        "portB": 20,
                        "outA": -1
                    },
                    "in": {
                        "portA": 10,
                        "portB": 20,
                        "outA": -1
                    },
                    "out": {
                        "portA": 10,
                        "portB": 20,
                        "outA": -1
                    }
                },
                "outConfig": {
                    "portA": 10,
                    "portB": 20,
                    "outA": -1
                }
            }
        },
        "addRight_step": {
            "type": "app.CircularModel",
            "size": {
                "width": 5,
                "height": 3
            },
            "inPorts": ["in1", "in2"],
            "outPorts": ["out"],
            "svconfig": {
                "portConfig": {
                    "portA": "START",
                    "portB": "START",
                    "outA": "FLOW"
                },
                "endPoint": {
                    "url": "http://localhost:3004/add",
                    "configSchema": {
                        "portA": 30,
                        "portB": 10,
                        "outA": -1
                    },
                    "in": {
                        "portA": 50,
                        "portB": 50,
                        "outA": -1
                    },
                    "out": {
                        "portA": 30,
                        "portB": 10,
                        "outA": -1
                    }
                },
                "outConfig": {
                    "portA": 10,
                    "portB": 20,
                    "outA": -1
                }
            }
        },
        "multiply_step": {
            "type": "app.CircularModel",
            "size": {
                "width": 5,
                "height": 3
            },
            "outPorts": ["out"],
            "inPorts": ["in1", "in2"],
            "svconfig": {
                "portConfig": {
                    "portA": "VAR_SV",
                    "portB": "VAR_SV",
                    "outA": "END"
    
                },
                "endPoint": {
                    "url": "http://localhost:3004/multiply",
                    "configSchema": {
                        "portA": 20,
                        "portB": 30,
                        "outA": -1
                    },
                    "in": {
    
                        "portA": 40,
                        "portB": 50,
                        "outA": -1
                    },
                    "out": {
                        "portA": 50,
                        "portB": 300,
                        "outA": -1
                    }
                },
                "outConfig": {
                    "portA": 10,
                    "portB": 20,
                    "outA": -1
                }
            }
        }
    },
    "SVCOMTYPE":"LINE"
},
  strandsDynaData:{
    
  currentStrandDataMemory:null,
  modalBaShow:false,

  svconfig :{
    "SVCOMTYPE":"LINE",
    "portConfig": {
        "stepPositionInParallelGate":"END",
        "portA": "VAR_SV",
        "portB": "VAR_SV",
        "outA": "END"

    },
    "endPoint": {
        "url": "http://localhost:3004/multiply",
        "configSchema": {
            "portA": 20,
            "portB": 30,
            "outA": -1
        },
        "in": {

            "portA": 40,
            "portB": 50,
            "outA": -1




        },
        "out": {
            "portA": 50,
            "portB": 300,
            "outA": -1
        }

    },
    "outConfig": {
        "portA": 10,
        "portB": 20,
        "outA": -1
    }
},  
  strands:[{
    "name": "strand1",
    "rna":{
      "enzyme":{
        "portA":    "347440",
        "portB":    "347440",
        "outA":    "347440"

      }

  },
    "bindingAcceptorParalle": {
      "name": "paralle3Gate_strand",
      "bus": [{
        "id": "addLeft_STEP",
        "inputPorts": ["portA", "portB"],
        "gene": "addLeft_STEP",
        "location": "START",
        "input": {
          "bindingType": "json",
          "portA": {
            "input": 661,
            "type": "number"
          },
          "portB": {
            "input": 666,
            "type": "number"
          }
        }
      }, {
  
        "id": "addRight_STEP",
        "inputPorts": ["portA", "portB"],
        "gene": "addRight_STEP",
        "location": "START",
        "input": {
          "bindingType": "json",
          "portA": {
            "input": 772,
            "type": "number"
          },
          "portB": {
            "input": 777,
            "type": "number"
          }
        }
      }, {
        "id": "multiply_step",
        "inputPorts": ["portA", "portB"],
        "gene": "multiply_step",
        "location": "CARRIER",
        "input": {
          "bindingType": "json",
          "portA": {
  
            "input": {
              "gene": "addLeft_step",
              "portRef": "outA",
              "type": "number"
            },
            "type": "FLOW_OBJECT_SV"
          },
          "portB": {
            "input": {
              "gene": "addRight_step",
              "portRef": "outA",
              "type": "number"
            },
            "type": "FLOW_OBJECT_SV"
          }
        }
      }]
  
    },
    "status": "incomplete",
    "aiexecview": "yes",
  
    "strandPrallel": {
  
      "dna": {
  
        "addLeft_step": {
  
          "type": "app.CircularModel",
          "size": {
            "width": 5,
            "height": 3
          },
          "inPorts": ["in1", "in2"],
          "outPorts": ["out"],
          "svconfig": {
  
            "portConfig": {
              "portA": "START",
              "portB": "START",
              "outA": "FLOW"
  
            },
            "endPoint": {
              "url": "http://localhost:3004/add",
              "configSchema": {
                "portA": 10,
                "portB": 20,
                "outA": -1
              },
              "in": {
  
                "portA": 10,
                "portB": 20,
                "outA": -1
  
  
  
  
              },
              "out": {
                "portA": 10,
                "portB": 20,
                "outA": -1
              }
  
            },
            "outConfig": {
              "portA": 10,
              "portB": 20,
              "outA": -1
            }
          }
  
        },
        "addRight_step": {
  
          "type": "app.CircularModel",
          "size": {
            "width": 5,
            "height": 3
          },
          "inPorts": ["in1", "in2"],
          "outPorts": ["out"],
          "svconfig": {
  
            "portConfig": {
              "portA": "START",
              "portB": "START",
              "outA": "FLOW"
  
            },
            "endPoint": {
              "url": "http://localhost:3004/add",
              "configSchema": {
                "portA": 30,
                "portB": 10,
                "outA": -1
              },
              "in": {
  
                "portA": 50,
                "portB": 50,
                "outA": -1
  
  
  
  
              },
              "out": {
                "portA": 30,
                "portB": 10,
                "outA": -1
              }
  
            },
            "outConfig": {
              "portA": 10,
              "portB": 20,
              "outA": -1
            }
          }
  
        },
        "multiply_step": {
  
          "type": "app.CircularModel",
          "size": {
            "width": 5,
            "height": 3
          },
          "outPorts": ["out"],
          "inPorts": ["in1", "in2"],
          "svconfig": {
  
            "portConfig": {
              "portA": "VAR_SV",
              "portB": "VAR_SV",
              "outA": "END"
  
            },
            "endPoint": {
              "url": "http://localhost:3004/multiply",
              "configSchema": {
                "portA": 20,
                "portB": 30,
                "outA": -1
              },
              "in": {
  
                "portA": 40,
                "portB": 50,
                "outA": -1
  
  
  
  
              },
              "out": {
                "portA": 50,
                "portB": 300,
                "outA": -1
              }
  
            },
            "outConfig": {
              "portA": 10,
              "portB": 20,
              "outA": -1
            }
          }
  
        }
      }
    }
  
  }, {
  
  
    "name": "strand2",
    "rna":{
      "enzyme":{
        "portA":    "347440",
        "portB":    "347440",
        "outA":    "347440"

      }

  },
    "bindingAcceptorParalle": {
      "name": "paralle3Gate_strand2",
      "bus": [{
        "id": "addLeft_STEP",
        "inputPorts": ["portA", "portB"],
        "gene": "addLeft_STEP",
        "location": "START",
        "input": {
          "bindingType": "json",
          "portA": {
            "input": 661,
            "type": "number"
          },
          "portB": {
            "input": 666,
            "type": "number"
          }
        }
      }, {
  
        "id": "addRight_STEP",
        "inputPorts": ["portA", "portB"],
        "gene": "addRight_STEP",
        "location": "START",
        "input": {
          "bindingType": "json",
          "portA": {
            "input": "772",
            "type": "number"
          },
          "portB": {
            "input": 777,
            "type": "number"
          }
        }
      }, {
        "id": "multiply_step",
        "inputPorts": ["portA", "portB"],
        "gene": "multiply_step",
        "location": "CARRIER",
        "input": {
          "bindingType": "json",
          "portA": {
  
            "input": {
              "gene": "addLeft_step",
              "portRef": "outA",
              "type": "number"
            },
            "type": "FLOW_OBJECT_SV"
          },
          "portB": {
            "input": {
              "gene": "addRight_step",
              "portRef": "outA",
              "type": "number"
            },
            "type": "FLOW_OBJECT_SV"
          }
        }
      }]
  
    },
    "status": "incomplete",
    "aiexecview": "yes",
    "strandPrallel": {
          "dna":{
  
  
      "addLeft_step": {
  
        "type": "app.CircularModel",
        "size": {
          "width": 5,
          "height": 3
        },
        "inPorts": ["in1", "in2"],
        "outPorts": ["out"],
        "svconfig": {
  
          "portConfig": {
            "portA": "START",
            "portB": "START",
            "outA": "FLOW"
  
          },
          "endPoint": {
            "url": "http://localhost:3004/add",
            "configSchema": {
              "portA": 10,
              "portB": 20,
              "outA": -1
            },
            "in": {
  
              "portA": 10,
              "portB": 20,
              "outA": -1
  
  
  
  
            },
            "out": {
              "portA": 10,
              "portB": 20,
              "outA": -1
            }
  
          },
          "outConfig": {
            "portA": 10,
            "portB": 20,
            "outA": -1
          }
        }
  
      },
      "addRight_step": {
  
        "type": "app.CircularModel",
        "size": {
          "width": 5,
          "height": 3
        },
        "inPorts": ["in1", "in2"],
        "outPorts": ["out"],
        "svconfig": {
  
          "portConfig": {
            "portA": "START",
            "portB": "START",
            "outA": "FLOW"
  
          },
          "endPoint": {
            "url": "http://localhost:3004/add",
            "configSchema": {
              "portA": 30,
              "portB": 10,
              "outA": -1
            },
            "in": {
  
              "portA": 30,
              "portB": 10,
              "outA": -1
  
  
  
  
            },
            "out": {
              "portA": 30,
              "portB": 10,
              "outA": -1
            }
  
          },
          "outConfig": {
            "portA": 10,
            "portB": 20,
            "outA": -1
          }
        }
  
      },
      "multiply_step": {
  
        "type": "app.CircularModel",
        "size": {
          "width": 5,
          "height": 3
        },
        "outPorts": ["out"],
        "inPorts": ["in1", "in2"],
        "svconfig": {
  
          "portConfig": {
            "portA": "VAR_SV",
            "portB": "VAR_SV",
            "outA": "END"
  
          },
          "endPoint": {
            "url": "http://localhost:3004/multiply",
            "configSchema": {
              "portA": 10,
              "portB": 20,
              "outA": -1
            },
            "in": {
  
              "portA": 10,
              "portB": 20,
              "outA": -1
  
  
  
  
            },
            "out": {
              "portA": 10,
              "portB": 20,
              "outA": -1
            }
  
          },
          "outConfig": {
            "portA": 10,
            "portB": 20,
            "outA": -1
          }
        }
  
      }
    }
      }
  
  }]

  },
  strandData:{
    id:'addLeft_step',
    gene:'addLeft_step',
    

  },
  pdData:{
    "id": "addLeft_step",
    "gene": "addLeft_step",
    "dcountry": "China",
    "fname": "John",
    "lname": "Glen",
    "email": "john123@yahoo.com",
    "address": "790 J St, Lincoln",
    "city": "Lincoln",
    "state": "CA",
    "zip": "95648",
    "country": "usa",
    "isdcode": "+1",
    "phone": "916-645-6360",
    "bookingAgentType": "self",
    "traveType": "Personal",
    "gname": "jenny",
    "gemail": "jenny@yahoo.com",
    "specialRequests": "Wheel chair and Senior Citizen",
    "card": "1234-1234--1234--1234",
    "cvv": "Glen",
    "mmexp": "04",
    "yyyyexp": "2028"
  
    

  },
  fpdData:{
    "id": "addLeft_step",
    "dateOfBirth": "1982-01-15",
    "gender": "MALE",

    "gene": "addLeft_step",
    "dcountry": "China",
    "fname": "John",
    "lname": "Glen",
    "email": "john123@yahoo.com",
    "address": "790 J St, Lincoln",
    "city": "Lincoln",
    "state": "CA",
    "zip": "95648",
    "country": "usa",
    "isdcode": "+1",
    "phone": "916-645-6360",
    "bookingAgentType": "self",
    "traveType": "Personal",
    "gname": "jenny",
    "gemail": "jenny@yahoo.com",
    "specialRequests": "Wheel chair and Senior Citizen",
    "card": "1234-1234--1234--1234",
    "cvv": "Glen",
    "mmexp": "04",
    "yyyyexp": "2028"
  
  
    

  },
  tppData:{
    "id": "addLeft_step",
    "testlastName": "svlondon",
    "dateOfBirth": "1982-01-15",
    "members": [
        {
            "tid": 1,
            "dateOfBirth": "1982-01-15",
            "gender": "MALE",
            "firstName": "Svbsv",
            "lastName": "Infinity",
            "emailAddress": "svr@yahoo.com",
            "memphones": [
                {
                    "deviceType": "MOBILE",
                    "countryCallingCode": "34",
                    "number": "480080085"
                }
            ],
            "members": [
                {
                    "documentType": "IDENTITY_CARD",
                    "birthPlace": "Sanfrancisco",
                    "issuanceLocation": "Sanfrancisco",
                    "issuanceDate": "2015-04-13",
                    "documentNumber": "00000069",
                    "expiryDate": "2025-04-13",
                    "issuanceCountry": "US",
                    "validityCountry": "US",
                    "nationality": "US",
                    "holder": "Y"
                }
            ],
            "id": "addLeft_STEP",
            "gene": "addLeft_STEP",
            "clubName": "SVFootbal"
        },
        {
            "tid": 2,
            "dateOfBirth": "1982-01-15",
            "gender": "MALE",
            "firstName": "Seteve",
            "lastName": "Borrow",
            "emailAddress": "steve@yahoo.com",
            "memphones": [
                {
                    "deviceType": "MOBILE",
                    "countryCallingCode": "1",
                    "number": "480080081"
                }
            ],
            "members": [
                {
                    "documentType": "IDENTITY_CARD",
                    "birthPlace": "Sanfrancisco",
                    "issuanceLocation": "Sanfrancisco",
                    "issuanceDate": "2015-04-13",
                    "documentNumber": "00000069",
                    "expiryDate": "2025-04-13",
                    "issuanceCountry": "US",
                    "validityCountry": "US",
                    "nationality": "US",
                    "holder": "Y"
                }
            ],
            "id": "addLeft_STEP1",
            "gene": "addLeft_STEP1",
            "clubName": "Soccer"
        }
    ],
       "gender": "MALE"
},
/*svnov17 start */
mciData:{
  "id": "addLeft_step",
  "testlastName": "svlondonKW",
  "gene":"svgene",
 
  "members": [
      {
          "tid": 1,
          "my_orgqueryText": "JFK",
          "my_dstqueryText": "LAX",
          "mcicountryOrg":"US",
          "mcicountryDst":"US",
          "STARTDATE":"2024-12-03",
          "DT_FORMAT": "%Y-%m-%d",
          "time_zone": "Asia/Kolkata"
         
      },
      {
          "tid": 2,
          "my_orgqueryText": "LAX",
          "my_dstqueryText": "SFO",
          "mcicountryOrg":"US",
          "mcicountryDst":"US",
          "STARTDATE":"2024-12-07",
          "DT_FORMAT": "%Y-%m-%d",
          "time_zone": "Asia/Kolkata"
         
      },
      {
          "tid": 3,
          "my_orgqueryText": "SFO",
          "my_dstqueryText": "JFK",
          "mcicountryOrg":"US",
          "mcicountryDst":"US",
          "STARTDATE":"2024-12-17",
          "DT_FORMAT": "%Y-%m-%d",
          "time_zone": "Asia/Kolkata"
         
      }
  ],
     "gender": "MALE"

  
},
/*svnov17 end */
  fppData:{
    "tid":1,
    "dateOfBirth": "1982-01-15",
    "gender": "MALE",
    "firstName": "Svbsv",
    "lastName": "Infinity",
    "emailAddress": "svr@yahoo.com",
    "memphones":[{       
        "deviceType": "MOBILE",
        "countryCallingCode": "34",
        "number": "480080085"
    }],
    "members": [
      {
        "documentType": "IDENTITY_CARD",
        "birthPlace": "Madrid",
        "issuanceLocation": "Madrid",
        "issuanceDate": "2015-04-13",
        "documentNumber": "00000069",
        "expiryDate": "2025-04-13",
        "issuanceCountry": "ES",
        "validityCountry": "ES",
        "nationality": "ES",
        "holder": "Y"
      }
    ],
    id:'addLeft_STEP',
    gene:'addLeft_STEP',
    "clubName": "Soccer"
  
  
  },
  tpiData:{
    "id": "addLeft_step",
    "testlastName":"svlondon",

    "dateOfBirth": "1982-01-15",
    "members":[{
      "tid":1,
      "dateOfBirth": "1982-01-15",
      "gender": "MALE",
      "firstName": "Svbsv",
      "lastName": "Infinity",
      "emailAddress": "svr@yahoo.com",
      "memphones":[{       
          "deviceType": "MOBILE",
          "countryCallingCode": "34",
          "number": "480080085"
      }],
      "members": [
        {
          "documentType": "IDENTITY_CARD",
          "birthPlace": "Sanfrancisco",
          "issuanceLocation": "Sanfrancisco",
          "issuanceDate": "2015-04-13",
          "documentNumber": "00000069",
          "expiryDate": "2025-04-13",
          "issuanceCountry": "US",
          "validityCountry": "US",
          "nationality": "US",
          "holder": "Y"
        }
      ],
      id:'addLeft_STEP',
      gene:'addLeft_STEP',
      "clubName": "Soccer"
    
    
    },{
      "tid":2,
      "dateOfBirth": "1982-01-15",
      "gender": "MALE",
      "firstName": "Seteve",
      "lastName": "Borrow",
      "emailAddress": "steve@yahoo.com",
      "memphones":[{       
          "deviceType": "MOBILE",
          "countryCallingCode": "1",
          "number": "480080081"
      }],
      "members": [
        {
          "documentType": "IDENTITY_CARD",
          "birthPlace": "Sanfrancisco",
          "issuanceLocation": "Sanfrancisco",
          "issuanceDate": "2015-04-13",
          "documentNumber": "00000069",
          "expiryDate": "2025-04-13",
          "issuanceCountry": "US",
          "validityCountry": "US",
          "nationality": "US",
          "holder": "Y"
        }
      ],
      id:'addLeft_STEP1',
      gene:'addLeft_STEP1',
      "clubName": "Soccer"
    
    
    }],
    "members_old": [
      {
        "documentType": "IDENTITY_CARD",
        "birthPlace": "Sanfrancisco",
        "issuanceLocation": "Sanfrancisco",
        "issuanceDate": "2015-04-13",
        "documentNumber": "00000069",
        "expiryDate": "2025-04-13",
        "issuanceCountry": "US",
        "validityCountry": "US",
        "nationality": "US",
        "holder": "Y"
      }
    ],
    "gender": "MALE"
   
  },
  tpiData_bad:{
    "testlastName": "tpi_step",
  
    "members" : [{
      "tid":1,
      "dateOfBirth": "1982-01-15",
      "gender": "MALE",
      "firstName": "Svbsv",
      "lastName": "Ixnfinity",
      "emailAddress": "svr@yahoo.com",
      "memphones":[{       
          "deviceType": "MOBILE",
          "countryCallingCode": "34",
          "number": "480080085"
      }],
      "members": [
        {
          "documentType": "IDENTITY_CARD",
          "birthPlace": "Sanfrancisco",
          "issuanceLocation": "Sanfrancisco",
          "issuanceDate": "2015-04-13",
          "documentNumber": "00000069",
          "expiryDate": "2025-04-13",
          "issuanceCountry": "US",
          "validityCountry": "US",
          "nationality": "US",
          "holder": "Y"
        }
      ],
      id:'addLeft_STEP',
      gene:'addLeft_STEP',
      "clubName": "Soccer"
    
    
    }]

  },
  rcData:{

    "status":"OK",
    "confirmationNumber":"UU12345",
    "chekinDate":"Jan 3027"
},
  pcData:{
    "id": "addLeft_step",

   
    "card": "1234-1234--1234--1234",
    "cvv": "Glen",
    "mmexp": "04",
    "yyyyexp": "28",
    "otherDetails" :"SVMed facility",
    "specialRequests": "Wheel chair and Senior Citizen",
    "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst"
  
    

  },
  frcData:{

    "status":"OK",
    "confirmationNumber":"AA12345",
    "chekinDate":"Oct 3025"
},
/*svmay21 start*/
//digverify
sjsjcData:{
  "id": "addVpc_step",

  "email": "mm22@yahoo.com",
  "subject": "MM Dtoken  Details",
  "customerId": "-131",
  "status": "OK",
  "digitalCode": "333333"

  

},
sjcpdData:{
  "id": "addLeft_step",
  "gene": "addLeft_step",
  "dcountry": "China",
  "fname": "John",
  "lname": "Glen",
  "email": "john123@yahoo.com",
  "address": "790 J St, Lincoln",
  "city": "Lincoln",
  "state": "CA",
  "zip": "95648",
  "country": "usa",
  "isdcode": "+1",
  "disdcode": "+1",
  "phone": "916-645-6360",
  "bookingAgentType": "self",
  "traveType": "Personal",
  "gname": "jenny",
  "gemail": "jenny@yahoo.com",
  "specialRequests": "Wheel chair and Senior Citizen",
  "card": "1234-1234--1234--1234",
  "cvv": "Glen",
  "mmexp": "04",
  "yyyyexp": "2028"

  

},
sjcpcData:{
  "id": "addLeft_step",

 
  "card": "1234-1234--1234--1234",
  "cvv": "Glen",
  "mmexp": "04",
  "yyyyexp": "28",
  "otherDetails" :"SVMed facility",
  "specialRequests": "Wheel chair and Senior Citizen",
  "privateparking":false,
      "rentcar":false,
      "bookTaxi":false,
      "needFlight":false,
      "arrivalTimeZone":"tz_pst"

  

},
sjcrcData:{

  "status":"OK",
  "confirmationNumber":"UU12345",
  "chekinDate":"Jan 3027"
},


/*svmay21 end*/


vpcData:{
  "id": "addVpc_step",

  "email": "mm22@yahoo.com",
  "subject": "MM Dtoken  Details",
  "customerId": "-131",
  "status": "OK",
  "digitalCode": "333333"

  

},
  fpcData:{
    "id": "addLeft_step",

   
    "card": "9999999999999999",
    "cvv": "999",
    "mmexp": "04",
    "yyyyexp": "28",
    "otherDetails" :"SVMed facility",
    "specialRequests": "Wheel chair and Senior Citizen",
    "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst"
  
    

  },
  strandDataMemory:{
    id:-1,
    
    gene:'addLeft_step',
    currentGenes:[{
      name:'addLeft_step',
      value:'addLeft_step'
  },{
      name:'addRight_step',
      value:'addRight_step'
    },{
      name:'multiply_step',
      value:'multiply_step'
    
    }],
    "name": "strand21",
    "stype": "converge",
    "rna":{
      "enzyme":{
        "portA":    "347440",
        "portB":    "347440",
        "outA":    "347440"

      }

  },
    "bindingAcceptorParalle": {
        "name": "paralle3Gate_strand",
        "bus": [{
            "id": "addLeft_step",
            "inputPorts": ["portA", "portB"],
            "gene": "addLeft_step",
            "location": "START",
            "input": {
                "bindingType": "json",
                "portA": {
                    "input": 661,
                    "type": "number"
                },
                "portB": {
                    "input": 666,
                    "type": "number"
                }
            }
        }, {

            "id": "addRight_step",
            "inputPorts": ["portA", "portB"],
            "gene": "addRight_step",
            "location": "START",
            "input": {
                "bindingType": "json",
                "portA": {
                    "input": 772,
                    "type": "number"
                },
                "portB": {
                    "input": 777,
                    "type": "number"
                }
            }
        }, {
            "id": "multiply_step",
            "inputPorts": ["portA", "portB"],
            "gene": "multiply_step",
            "location": "CARRIER",
            "input": {
                "bindingType": "json",
                "portA": {

                    "input": {
                        "gene": "addLeft_step",
                        "portRef": "outA",
                        "type": "number"
                    },
                    "type": "FLOW_OBJECT_SV"
                },
                "portB": {
                    "input": {
                        "gene": "addRight_step",
                        "portRef": "outA",
                        "type": "number"
                    },
                    "type": "FLOW_OBJECT_SV"
                }
            }
        }]

    },
    "status": "incomplete"
},
  cstepformbusDataMemory:{
    
    "members": [
      {
       
         "firstName": "Alex",
         "lastName": "tam",
        
         inputSchema:'',
         
         ype:'JSON',
         inputSchemaTypes:[{
          name:'JSON',
          value:'JSON'
        },{
          name:'XML',
          value:'XML'
        },{
          name:'SVG',
          value:'SVG'
        }],
         svfieldType:'CL_String',
         portId:'portB', 
         portName:'portB', 
         portType:'CL_Number',
         portInput :10,
         portTypes:[{
          key:'CL_Number',
          value:'number'
        },{
          key:'CL_String',
          value:'string'
        
        },{
          key:'CL_Date',
          value:'date'   
         
        }],
   
         locationId:'START',
         locationText:'Location',
         locationTypes:[{
          name:'START',
          value:'START'
      },{
          name:'CARRIER',
          value:'CARRIER'
      },{
          name:'END',
          value:'END'
      }],
         tags:['cloud', 'svanalytics'],
         "hobbies": [
           "football"
         ]
       
      },{
         
       inputSchema:'',
       inputSchemaType:'JSON',
       inputSchemaTypes:[{
        name:'JSON',
        value:'JSON'
      },{
        name:'XML',
        value:'XML'
      },{
        name:'SVG',
        value:'SVG'
      }],
       svfieldType:'CL_Number',
       portId:'portA', 
       portName:'portA', 
       portType:'CL_Number',
       portInput :30,
       portTypes:[{
        key:'CL_Number',
        value:'number'
      },{
        key:'CL_String',
        value:'string'
      
      },{
        key:'CL_Date',
        value:'date'   
       
      }],
   
       locationId:'START',
       locationText:'Location',
       locationTypes:[{
        name:'START',
        value:'START'
    },{
        name:'CARRIER',
        value:'CARRIER'
    },{
        name:'END',
        value:'END'
    }],
       tags:['cloud', 'svanalytics'],
       "hobbies": [
         "football"
       ]
     }
    ],
    id:'addLeft_step',
    gene:'addLeft_step',
    bindingAcceptorName:'pipeSeq_Gate',
    bindingAcceptorName: "calculator_strand",
    clubName: "calculator_strand"
  

},
  cstepformbusData:{
    
    "members": [
      {
       
         "firstName": "Alex",
         "lastName": "tam",
        
         inputSchema:'',
         
         ype:'JSON',
         inputSchemaTypes:[{
          name:'JSON',
          value:'JSON'
        },{
          name:'XML',
          value:'XML'
        },{
          name:'SVG',
          value:'SVG'
        }],
         svfieldType:'CL_String',
         portId:'portB', 
         portName:'portB', 
         portType:'CL_Number',
         portInput :10,
         portTypes:[{
          key:'CL_Number',
          value:'number'
        },{
          key:'CL_String',
          value:'string'
        
        },{
          key:'CL_Date',
          value:'date'   
         
        }],
   
         locationId:'START',
         locationText:'Location',
         locationTypes:[{
          name:'START',
          value:'START'
      },{
          name:'CARRIER',
          value:'CARRIER'
      },{
          name:'END',
          value:'END'
      }],
         tags:['cloud', 'svanalytics'],
         "hobbies": [
           "football"
         ]
       
      },{
         
       inputSchema:'',
       inputSchemaType:'JSON',
       inputSchemaTypes:[{
        name:'JSON',
        value:'JSON'
      },{
        name:'XML',
        value:'XML'
      },{
        name:'SVG',
        value:'SVG'
      }],
       svfieldType:'CL_Number',
       portId:'portA', 
       portName:'portA', 
       portType:'CL_Number',
       portInput :30,
       portTypes:[{
        key:'CL_Number',
        value:'number'
      },{
        key:'CL_String',
        value:'string'
      
      },{
        key:'CL_Date',
        value:'date'   
       
      }],
   
       locationId:'START',
       locationText:'Location',
       locationTypes:[{
        name:'START',
        value:'START'
    },{
        name:'CARRIER',
        value:'CARRIER'
    },{
        name:'END',
        value:'END'
    }],
       tags:['cloud', 'svanalytics'],
       "hobbies": [
         "football"
       ]
     }
    ],
    id:'addLeft_step',
    gene:'addLeft_step',
    bindingAcceptorName:'pipeSeq_Gate',
    bindingAcceptorName: "calculator_strand",
    clubName: "calculator_strand"
  

},
camciformepData:{
  "id": "addLeft_step",
  "testlastName": "svlondonKW",
  "gene":"svgene",
 
  "members": [
      {
          "tid": 1,
          "my_orgqueryText": "JFK",
          "my_dstqueryText": "LAX",
          "mcicountryOrg":"US",
          "mcicountryDst":"US",
          "STARTDATE":"2024-12-03",
          "DT_FORMAT": "%Y-%m-%d",
          "time_zone": "Asia/Kolkata"
         
      },
      {
          "tid": 2,
          "my_orgqueryText": "LAX",
          "my_dstqueryText": "SFO",
          "mcicountryOrg":"US",
          "mcicountryDst":"US",
          "STARTDATE":"2024-12-07",
          "DT_FORMAT": "%Y-%m-%d",
          "time_zone": "Asia/Kolkata"
         
      },
      {
          "tid": 3,
          "my_orgqueryText": "SFO",
          "my_dstqueryText": "JFK",
          "mcicountryOrg":"US",
          "mcicountryDst":"US",
          "STARTDATE":"2024-12-17",
          "DT_FORMAT": "%Y-%m-%d",
          "time_zone": "Asia/Kolkata"
         
      }
  ],
     "gender": "MALE"
},
catocformepData:{
  "id": "addLeft_step",
  "testlastName": "svlondon",
  "dateOfBirth": "1982-01-15",
  "members": [
      {
          "tid": 1,
          "dateOfBirth": "1982-01-15",
          "gender": "MALE",
          "firstName": "Svbsv",
          "lastName": "Infinity",
          "emailAddress": "svr@yahoo.com",
          "memphones": [
              {
                  "deviceType": "MOBILE",
                  "countryCallingCode": "34",
                  "number": "480080085"
              }
          ],
          "members": [
              {
                  "documentType": "IDENTITY_CARD",
                  "birthPlace": "Sanfrancisco",
                  "issuanceLocation": "Sanfrancisco",
                  "issuanceDate": "2015-04-13",
                  "documentNumber": "00000069",
                  "expiryDate": "2025-04-13",
                  "issuanceCountry": "US",
                  "validityCountry": "US",
                  "nationality": "US",
                  "holder": "Y"
              }
          ],
          "id": "addLeft_STEP",
          "gene": "addLeft_STEP",
          "clubName": "Soccer"
      },
      {
          "tid": 2,
          "dateOfBirth": "1982-01-15",
          "gender": "MALE",
          "firstName": "Seteve",
          "lastName": "Borrow",
          "emailAddress": "steve@yahoo.com",
          "memphones": [
              {
                  "deviceType": "MOBILE",
                  "countryCallingCode": "1",
                  "number": "480080081"
              }
          ],
          "members": [
              {
                  "documentType": "IDENTITY_CARD",
                  "birthPlace": "Sanfrancisco",
                  "issuanceLocation": "Sanfrancisco",
                  "issuanceDate": "2015-04-13",
                  "documentNumber": "00000069",
                  "expiryDate": "2025-04-13",
                  "issuanceCountry": "US",
                  "validityCountry": "US",
                  "nationality": "US",
                  "holder": "Y"
              }
          ],
          "id": "addLeft_STEP1",
          "gene": "addLeft_STEP1",
          "clubName": "Soccer"
      }
  ],
     "gender": "MALE"
},
cadocformepData:{
    
  "members": [
    {
      "documentType": "IDENTITY_CARD",
      "birthPlace": "Madrid",
      "issuanceLocation": "Madrid",
      "issuanceDate": "2015-04-13",
      "documentNumber": "00000069",
      "expiryDate": "2025-04-13",
      "issuanceCountry": "ES",
      "validityCountry": "ES",
      "nationality": "ES",
      "holder": "Y"
    }
  ],
  id:'addLeft_STEP',
  gene:'addLeft_STEP',
  "clubName": "Soccer"


},

  cstepformepData:{
    
    "members": [
      {
        "firstName": "Alex",
        "lastName": "tam",
        portId:'portB', 
        portName:'portB', 
        portType:'CL_Number',
        portInput :10,
        portTypes,

        locationId:'location2',
        locationText:'Location',
        locationTypes,
        "hobbies": [
          "football"
        ]
      }
    ],
    id:'addLeft_STEP',
    gene:'addLeft_STEP',
    "clubName": "Soccer"
  

},
  cstepformData:{
    
      "members": [
        {
          "firstName": "Alex",
          "lastName": "tam",
          "hobbies": [
            "football"
          ]
        }
      ],
      "clubName": "Soccer"
    

  },
  monformData:{

    "faWidgets":[
      {
        "widgetName": "CPU_WIDGET",
       "widgetType": "SVSYSTEM_WIDGET",
       
      
       "hobbies": [
         "football"
       ]
      },{
        "widgetName": "T_2",
       "widgetType": "SVSYSTEM_WIDGET",
       
      
       "svarEnv": [
         "DEV"
       ]
      }

    ],
    
    "members": [
      {
        "widgetName": "cpuWidgetSystem",
       "widgetType": "SYSTEM_WIDGET",
       
      
       "hobbies": [
         "football"
       ]
      }
    ],
    "layout": "4X4",
    "dbName": "svDBName1"
},

  monitorformData:{

    "faWidgets":[
      {
        "widgetName": "CPU_WIDGET",
       "widgetType": "SVSYSTEM_WIDGET",
       
      
       "hobbies": [
         "football"
       ]
      },{
        "widgetName": "T_2",
       "widgetType": "SVSYSTEM_WIDGET",
       
      
       "svarEnv": [
         "DEV"
       ]
      }

    ],
    
    "members": [
      {
        "widgetName": "cpuWidgetSystem",
       "widgetType": "SYSTEM_WIDGET",
       
      
       "hobbies": [
         "football"
       ]
      }
    ],
    "dbName": "svDBName1"
},

  classifierData:{
    svfieldType:'CL_Number',
    sex:'male',
    id:'addLeft_STEP',
    gene:'addLeft_STEP',
    lastName:'add_step',
    portType:'number',
    portInput :10,
    location:'START'
  },
  classifierStep:{
    svfieldType:'CL_Number',
    sex:'male',
    id:'addLeft_STEP',
    gene:'addLeft_STEP',
    lastName:'add_step',
    portType:'number',
    portInput :10,
    location:'START'
  },
  counterData:{
    amount:5,
    direction:'up'
  },
  flowData:{

     // used to populate "account" reducer when "Load" is clicked
        firstName: 'Jane',
        lastName: 'Doe',
        age: '42',
        sex: 'female',
        employed: true,
        favoriteColor: 'Blue',
        bio: 'Born to write amazing Redux code.',
        "name":"pdfTask",
        "description":"Alll tasks",
         "configSchema":"<pdfTask></pdfTask>",
          teditor: {
            value: `{
                "name": "sv",
                "modettt": "sv"
            }`,
          theme: 'github',
          mode: 'json',
          enableBasicAutocompletion: false,
          enableLiveAutocompletion: false,
          fontSize: 14,
          showGutter: true,
          showPrintMargin: true,
          highlightActiveLine: true,
          enableSnippets: false,
          showLineNumbers: true

        },
   
        taskName:'svname',
        taskDesc:'svdesc',
        taskType: 'single',
        runNow:'svyes'
  },
  stepData:{
    id:-1,
    // used to populate "account" reducer when "Load" is clicked
    firstName: 'Jane',
    lastName: 'Doe',
    age: '42',
    sex: 'female',
    employed: true,
    favoriteColor: 'Blue',
    bio: 'Born to write amazing Redux code.'
  },	
  teditor: {
    value: `{
         "name": "sv",
         "modettt": "sv"
     }`,
   theme: 'github',
   mode: 'json',
   enableBasicAutocompletion: false,
   enableLiveAutocompletion: false,
   fontSize: 14,
   showGutter: true,
   showPrintMargin: true,
   highlightActiveLine: true,
   enableSnippets: false,
   showLineNumbers: true

 },
	movies: [],
    movie: {},
    endpoints:[],
    tasks:svtasks,
    task:{ 
          "id":-1,
        "name":"",
        "description":"",
        "configSchema":"<pdfTaskNew></pdfTaskNew>",
        "endpoints":[{
          "url":"execute1",
          "inputSchema":"",
          "outputSchema":""
		
    }]
  }
}

export const SVTasksReducer = (state = initialState, action={ type: null }) => {
 // export const SVTasksReducer=(state =initialState, action={type:null})=>{
console.log('sv--taskreducers---')
  console.log(action)
  console.log(state)
   let nsvdoc = {}
   let nsvtoc = {}
   let nsvmci = {}
    let svns= null
    let id = -1
    let tasks = null
    let arfound = false
    let found = false
    let strandsDynaData,  svgateChartDyna
     let modState = Object.assign({}, initialState)

     console.log('--SVTaskreducer got action-------------------------------------'+ action.type)
//@@redux/PROBE_UNKNOWN_ACTIONi.7.n.k.m.9
 let probe = action.type
 let SVACTIONTYPE = action.type
 let probeSize = '@@redux/PROBE_UNKNOWN_ACTION'.length
 let probeRandom =  probe.substr(0, probeSize )
 if(probeRandom === '@@redux/PROBE_UNKNOWN_ACTION'){
  SVACTIONTYPE = '@@redux/PROBE_UNKNOWN_ACTIONi.7.n.k.m.9'
 }
 console.log(probeRandom)
	switch(SVACTIONTYPE){
    case '@@redux-form/CHANGE' || '@@redux/PROBE_UNKNOWN_ACTIONi.7.n.k.m.9':
    let {meta,payload} = action
    if(meta.form == SVSTRANDFORM){
      let geneName =  payload 
      let strandData = {
        id:geneName,
        gene:geneName
      }
      modState = Object.assign({}, state, {strandData:strandData})
//svmay21 start SJPCFORM'
}else if(meta.form == SJSJCFORM) {

  let geneName =  payload 
  let sjsjcData = {
    id:geneName,
    gene:geneName
  }
  modState = Object.assign({}, state, {sjsjcData:sjsjcData})

}else if(meta.form == CRPCFORM) {

  let geneName =  payload 
  let crpcData = {
    id:geneName,
    gene:geneName
  }
  modState = Object.assign({}, state, {crpcData:crpcData})

  

}else if(meta.form == SJPCFORM) {

  let geneName =  payload 
  let sjpcData = {
    id:geneName,
    gene:geneName
  }
  modState = Object.assign({}, state, {sjpcData:sjpcData})

  
}else if(meta.form == SJRCFORM) {

  let geneName =  payload 
  let sjrcData = {
    id:geneName,
    gene:geneName
  }
  modState = Object.assign({}, state, {sjrcData:sjrcData})
}else if(meta.form == CRRCFORM) {

  let geneName =  payload 
  let crrcData = {
    id:geneName,
    gene:geneName
  }
  modState = Object.assign({}, state, {crrcData:crrcData})

}else if(meta.form == CRPDFORM) {

  let geneName =  payload 
  let crpdData = {
    id:geneName,
    email:'sv@sv.com',
    gene:geneName
  }
  modState = Object.assign({}, state, {crpdData:crpdData})

    /*svmay21 end */

}else if(meta.form == SJPDFORM) {

  let geneName =  payload 
  let sjpdData = {
    id:geneName,
    email:'sv@sv.com',
    gene:geneName
  }
  modState = Object.assign({}, state, {sjpdData:sjpdData})

    /*svmay21 end */
    }else if(meta.form == SVRCFORM) {

      let geneName =  payload 
      let rcData = {
        id:geneName,
        gene:geneName
      }
      modState = Object.assign({}, state, {rcData:rcData})
    }else if(meta.form == SVPDFORM) {

      let geneName =  payload 
      let pdData = {
        id:geneName,
        email:'sv@sv.com',
        gene:geneName
      }
      modState = Object.assign({}, state, {pdData:pdData})
    }else if(meta.form == SVFRCFORM) {

      let geneName =  payload 
      let frcData = {

        "status":"OK",
        "confirmationNumber":"AA12345",
        "chekinDate":"Oct 3025"
    }
      modState = Object.assign({}, state, {frcData:frcData})
    }else if(meta.form == SVPCFORM) {

      let geneName =  payload 
      let pcData = {
        id:geneName,
        gene:geneName
      }
      modState = Object.assign({}, state, {pcData:pcData})

    }else if(meta.form == SVFPDFORM) {
      let geneName =  payload 
      let fpdData = {
        id:geneName,
        email:'sv@sv.com',
        gene:geneName
      }
      modState = Object.assign({}, state, {fpdData:fpdData})
      /*
      let {fpdData} = state
      let n = {...fpdData}
      console.log('sv**n', n)
      let f = meta.field
      n[f] = action.payload


      let geneName =  payload 
     */
      /*
      modState = Object.assign({}, state, {fpdData:n})
      */
      /*
      let fpdDataBad = {
        id:geneName,
        email:'sv@sv.com',
        gene:geneName
      }
      modState = Object.assign({}, state, {fpdData:fpdDataBad})
      */
    }else if(meta.form == SVTPPFORM) {
     //just passing so that ir doensot mofiies uservalues as gene is not used .
     /* let tppData = {
        id:geneName,
        email:'sv@sv.com',
        gene:payload
      }*/
      let tppData = {
        id:-4,
        email:'sv@sv.com',
        gene:'cat'
      }

      modState = Object.assign({}, state, {tppData:tppData})
      console.log('****svj22 Toc is tppData****')
      console.log(modState)
    }else if(meta.form == SVMCIFORM) {
      //just passing so that ir doensot mofiies uservalues as gene is not used .
      /* let tppData = {
         id:geneName,
         email:'sv@sv.com',
         gene:payload
       }*/
       let mciData = {
         id:-4,
         email:'sv@sv.com',
         gene:'cat'
       }
 
       modState = Object.assign({}, state, {mciData:mciData})
    }else if(meta.form == SVFPPFORM) {
      let geneName =  payload 
      let fppData = {
        id:geneName,
        email:'sv@sv.com',
        gene:geneName
      }
      modState = Object.assign({}, state, {fppData:fppData})
     
      /*
      let {fppData} = state
      let n = {...fppData}
      console.log('sv**n', n)
      let f = meta.field
      n[f] = action.payload


      let geneName =  payload 
     */
      /*
      modState = Object.assign({}, state, {fppData:n})
      */
      /*
      let fpdDataBad = {
        id:geneName,
        email:'sv@sv.com',
        gene:geneName
      }
      modState = Object.assign({}, state, {fppData:fpdDataBad})
      */
    }else if(meta.form == SVMCIFORM) {
      let geneName =  payload 
      let mciData = {
        id:geneName,
        email:'sv@sv.com',
        gene:geneName
      }
      modState = Object.assign({}, state, {mciData:mciData})
    }else if(meta.form == SVFPCFORM) {

      let geneName =  payload 
      let fpcData = {
        id:geneName,
        gene:geneName
      }
      modState = Object.assign({}, state, {fpcData:fpcData})
    }else if(meta.form == SVVPCFORM) {

      let geneName =  payload 
      let vpcData = {
        id:geneName,
        gene:geneName
      }
      modState = Object.assign({}, state, {vpcData:vpcData})


    }else if(meta.form == SVFPIFORM) {
      let geneName =  payload 
      let cadocformepData = {
        id:geneName,
       
        gene:geneName
      }
      modState = Object.assign({}, state, {cadocformepData:cadocformepData})
    }else if(meta.form == SVTPIFORM) {
      let geneName =  payload 
      let tpiData = {
        id:geneName,
       // "testlastName":"svfrance",
        gene:geneName
      }
      modState = Object.assign({}, state, {tpiData:tpiData})
    

    }else{

      console.log('sv no state change')
      modState = {...state}
    }
    console.log(modState)
     return modState
    break
    case HIDE_MODAL_BA:
    strandsDynaData = {...state.strandsDynaData} 
   console.log(strandsDynaData)
   strandsDynaData.modalBaShow = false
   modState = Object.assign({},state, {strandsDynaData:strandsDynaData})
    console.log(modState)
    return modState

  //sv just load as initialState
    break
    case SHOW_MODAL_BA:
    //we get just  strands:[] , modelBaShoe>true
   strandsDynaData = {...state.strandsDynaData} 
   console.log(strandsDynaData)
   strandsDynaData.modalBaShow = true
   strandsDynaData.currentGenes = action.currentGenes
   strandsDynaData.currentStrandDataMemory = action.currentStrandDataMemory
   modState = Object.assign({},state, {strandsDynaData:strandsDynaData})
  /*  modState = Object.assign({}, strandsDynaData, { modalBaShow:true
    })*/
    console.log(modState)
    return modState


    case SHOW_CHARTTYPE:
    //we get just  strands:[] , modelBaShoe>true
   let svgateChartContainerDyna = {...state.svgateChartContainerDyna} 
   console.log(svgateChartContainerDyna)
   
   modState = Object.assign({},state, {svgateChartContainerDyna:action.data})
  /*  modState = Object.assign({}, strandsDynaData, { modalBaShow:true
    })*/
    console.log(modState)
    return modState

    case CHANGE_DISPLAY_LINECHART:
    //we get just  strands:[] , modelBaShoe>true
    svgateChartDyna =  Object.assign({}, state.svgateChartDyna) 
    //shouldComponentUpdate
    /*svgateChartDyna.fromStrandIdx = action.fromStrandIdx
    svgateChartDyna.fromStrandName = action.fromStrandName
    svgateChartDyna.toSVCOMTYPE = action.toSVCOMTYPE
    svgateChartDyna.fromSVCOMTYPE = action.fromSVCOMTYPE
*/
    svgateChartDyna =  Object.assign({}, state.svgateChartDyna, {fromStrandIdx :action.fromStrandIdx,
      fromStrandName:action.fromStrandName,
      toSVCOMTYPE:action.toSVCOMTYPE,
      fromSVCOMTYPE:action.fromSVCOMTYPE
    
    }) 
   console.log(svgateChartDyna)
   svgateChartDyna.SVCOMTYPE = action.toSVCOMTYPE
   modState = Object.assign({},state, {svgateChartDyna:svgateChartDyna})
  /*  modState = Object.assign({}, strandsDynaData, { modalBaShow:true
    })*/
    console.log(action.fromStrandName + ':' +action.fromStrandIdx + 'changd from' + action.fromSVCOMTYPE + ':to:' + action.toSVCOMTYPE)
   // modState.strandsDynaData.strands[action.fromStrandIdx].strandPrallel.dna.multiply_step.svconfig.SVCOMTYPE = action.toSVCOMTYPE
    console.log(modState)
    return modState

    case SHOW_LINECHART:
    //we get just  strands:[] , modelBaShoe>true
    svgateChartDyna = {...state.svgateChartDyna} 
   console.log(svgateChartDyna)
   svgateChartDyna.svconfig = action.svconfig
   modState = Object.assign({},state, {svgateChartDyna:svgateChartDyna})
  /*  modState = Object.assign({}, strandsDynaData, { modalBaShow:true
    })*/
    console.log(modState)
    return modState

  //sv just load as initialState
    break
    case LOAD_SVSTRANDS_DYNA:

    modState = Object.assign({}, state, { strandsDynaData:action.strandsDynaData
    })
    console.log(modState)
    return modState

  //sv just load as initialState
    break
    case LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS:
    console.log('sv LOAD_STRAND_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS reducer - got action:')
    console.log(action.gene)
    modState = Object.assign({}, state, { strandData:action.strandData
    
    })
     console.log(modState)
     return modState

     case LOAD_STRAND_MEMORY_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS:
    console.log('sv LOAD_STRAND_MEMORY_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS reducer - got action:')
    console.log(action.strandDataMemory)
    modState = Object.assign({}, state, { strandDataMemory:action.strandDataMemory
    
    })
     console.log(modState)
     return modState
    case LOAD_TEMPLATE_DATA_CLASSIFIERSTEP_CSTEPFORM_BUS:
    console.log('sv LOAD_CLASSIFIERSTEP_CSTEPFORM reducer - got action:')
    console.log(action.templateData)
    modState = Object.assign({}, state, { cstepformbusData:action.templateData })
     console.log(modState)
     return modState
     case LOAD_GENE_UI_DATA_CSTEPFORM_BUS:
    console.log('sv LOAD_GENE_UI_DATA_CSTEPFORM_BUS reducer - got action:')
    console.log(action.templateData)
    modState = Object.assign({}, state, { cstepformbusDataMemory:action.templateData })
     console.log(modState)
     return modState 
    case LOAD_CLASSIFIERSTEP_CSTEPFORM_EP:
    console.log('sv LOAD_CLASSIFIERSTEP_CSTEPFORM reducer - got action:')
    console.log(action)
    modState= Object.assign({},state,{
       clubName:'ModFootballClub'
     } )
     console.log(modState)
     return modState
     case LOAD_CLASSIFIERSTEP_CSTEPFORM:
      console.log('sv LOAD_CLASSIFIERSTEP_CSTEPFORM reducer - got action:')
      console.log(action)
      modState= Object.assign({},state,{
         clubName:'ModFootballClub'
       } )
       console.log(modState)
       return modState
     case LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS:
    console.log('sv LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS reducer - got action:')
    console.log(action)
    modState= Object.assign({},state,{
       clubName:'ModFootballClub'
     } )
     console.log(modState)
     return modState 
    case LOAD_CLASSIFIERSTEP_CSTEPFORM:
    console.log('sv LOAD_CLASSIFIERSTEP_CSTEPFORM reducer - got action:')
    console.log(action)
    modState= Object.assign({},state,{
       clubName:'ModFootballClub'
     } )
     console.log(modState)
     return modState
    break
    case LOAD_GV:
    console.log('sv LOAD_GV reducer - got action:')
    console.log(action)
    /*
    modState= Object.assign({},state,{
       dbName:'svdbName1'
     } )

*/
     console.log(action.templateData)
    modState = Object.assign({}, state, { gvformData:action.templateData })
     console.log(modState)

     console.log(modState)
     return modState
     return modState
    break
    case LOAD_MON:
    console.log('sv LOAD_MON reducer - got action:')
    console.log(action)
    /*
    modState= Object.assign({},state,{
       dbName:'svdbName1'
     } )

*/
     console.log(action.templateData)
    modState = Object.assign({}, state, { mon:action.templateData })
    

     console.log(modState)
     return modState
    break
    case LOAD_MONS:
    console.log('sv LOAD_MONS reducer - got action:')
    console.log(action)
    /*
    modState= Object.assign({},state,{
       dbName:'svdbName1'
     } )

*/
   //  console.log(action.templateData)
    modState = Object.assign({}, state, { mons:action.templateData })
   

     console.log(modState)
     return modState
    break
    case LOAD_GVS:
    console.log('sv LOAD_GVS reducer - got action:')
    console.log(action)
    /*
    modState= Object.assign({},state,{
       dbName:'svdbName1'
     } )

*/
   //  console.log(action.templateData)
    modState = Object.assign({}, state, { gvs:action.templateData })
   

     console.log(modState)
     return modState
    break
    case LOAD_MON_MONFORM:
    console.log('sv LOAD_MON_MONFORM reducer - got action:')
    console.log(action)
    /*
    modState= Object.assign({},state,{
       dbName:'svdbName1'
     } )

*/
     console.log(action.templateData)
    modState = Object.assign({}, state, { monformData:action.templateData })
     console.log(modState)

     console.log(modState)
     return modState
    break
    case LOAD_MONITORS_MONITORFORM:
    console.log('sv LOAD_MONITORS_MONITORFORM reducer - got action:')
    console.log(action)
    /*
    modState= Object.assign({},state,{
       dbName:'svdbName1'
     } )

*/
     console.log(action.templateData)
    modState = Object.assign({}, state, { monitorformData:action.templateData })
     console.log(modState)

     console.log(modState)
     return modState
    break
    case LOAD_CLASSIFIER_FORM:
    console.log('sv classierdata reducer - got action:')
    console.log(action)
    modState= Object.assign({},state,{
       lastName:'SvNowLastName'
     } )
     console.log(modState)
     return modState
    break
    case COUNTER_ACTION:

        let nCounter={
          amount:6,
          direction:'up'
        }

        modState = Object.assign({}, state, {counterData:nCounter})
        return modState
    break
    case "task/CREATE_FLOW":
 console.log('create flowform reducer')
 let id = action.id
    if(id &&  (typeof(id)== 'number') ){
        id =action.id
      }else{
        id =  parseInt(action.id)
      }

      //sv step for id > -1 do fectch or call task/GET_TASK
     let nFlow = {
       // used to populate "account" reducer when "Load" is clicked
        firstName: 'Jane',
        lastName: 'Doe',
        age: '42',
        sex: 'female',
        employed: true,
        favoriteColor: 'Blue',
        bio: 'Born to write amazing Redux code.',
        "name":"pdfTask",
        "description":"Alll tasks",
        "configSchema":"<pdfTask></pdfTask>",
        teditor: {
          value: `{
               "name": "sv",
               "modettt": "sv"
           }`,
         theme: 'github',
         mode: 'json',
         enableBasicAutocompletion: false,
         enableLiveAutocompletion: false,
         fontSize: 14,
         showGutter: true,
         showPrintMargin: true,
         highlightActiveLine: true,
         enableSnippets: false,
         showLineNumbers: true
      
       },
        taskName:'svname',
        taskDesc:'svdesc',
        taskType: 'single',
        runNow:'svyes'
      }
      

  
/*
  let nTask =  {
                name:'',
                description:'',
                configSchema:''
            },
            value: `{
                "name": "sv",
                "modettt": "sv"
            }`,
      theme: 'github',
      mode: 'json',
      enableBasicAutocompletion: false,
      enableLiveAutocompletion: false,
      fontSize: 14,
      showGutter: true,
      showPrintMargin: true,
      highlightActiveLine: true,
      enableSnippets: false,
      showLineNumbers: true
        }*/
      if(id < 0){   
      }

     modState =  Object.assign({}, state, {
      flowData:nFlow
       
      })
    return modState


    break

		case "tasks/LIST_TASKS":

     console.log('tasks LIST reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.tasks) && (action.tasks.length >0)){
       
        state.tasks =_.clone(action.tasks)
      }
     svns = Object.assign({}, state, {tasks:action.tasks})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
/*svmay21 start*/
case 'SJRESERVATIONS_PRIMARY_ADDRESS':
        console.log("reduce %%%%%%%%GET_REVIEW_SUCCESS  success*****************");
        console.log(action.payload.my_data_address);
        let nSHAddress = {}
        if(action.payload.my_data_address){
          nSHAddress = action.payload.my_data_address
          modState =  Object.assign({}, state, {
            sjcpdData:nSHAddress
          
          })
        }
       

      
    return modState
case 'SOJMYRESERVATIONS_PRIMARY_CARD':
        console.log("reduce %%%%%%%%GET_REVIEW_SUCCESS  success*****************");
        console.log(action.payload.sj_data_card);
        let nCardSH = {}
        if(action.payload.sj_data_card){
          nCardSH = action.payload.sj_data_card
          modState =  Object.assign({}, state, {
            sjcpcData:nCardSH
          
          })
        }
       

      
   return modState
/*svmay21 end*/
case 'MYRESERVATIONS_PRIMARY_CARD':
        console.log("reduce %%%%%%%%GET_REVIEW_SUCCESS  success*****************");
        console.log(action.payload.my_data_card);
        let nCard = {}
        if(action.payload.my_data_card){
          nCard = action.payload.my_data_card
          modState =  Object.assign({}, state, {
            pcData:nCard
          
          })
        }
       

      
   return modState

case 'MYRESERVATIONS_PRIMARY_ADDRESS':
        console.log("reduce %%%%%%%%GET_REVIEW_SUCCESS  success*****************");
        console.log(action.payload.my_data_address);
        let nAddress = {}
        if(action.payload.my_data_address){
          nAddress = action.payload.my_data_address
          modState =  Object.assign({}, state, {
            pdData:nAddress
          
          })
        }
       

      
    return modState
   //FLYMYRESERVATIONS_PRIMARY_ADDRESS
case 'MYRESERVATIONS_PRIMARY_TPI':
    console.log("reduce %%%%%%%%MYRESERVATIONS_PRIMARY_TPI  success*****************");
    console.log(action.payload.nTpidata);
    let nTpidata = {"testlastName":"svitaly", "id":"34", "gene":"red_gene"}
    if(action.payload.tpiData){
      nTpidata = action.payload.tpiData
      modState =  Object.assign({}, state, {
        tpiData:nTpidata
      
      })
    }
   

  
return modState

case 'FLYMYRESERVATIONS_PRIMARY_SVTOC':
   //we donot wabt tp save in tsakercuder reviewreducer_cosmose saves it as savetpp aka submit needs teh vales

    console.log('sv FLYMYRESERVATIONS_PRIMARY_SVTOC reducer - got action:')
    console.log(action)
    console.log(action.payload.my_data_svtoc);
     nsvtoc = {}
    if(action.payload.my_data_flyaddress){
      nsvtoc = action.payload.my_data_svtoc
      modState =  Object.assign({}, state, {
        catocformepData:nsvtoc
      
      })
    }
     console.log(modState)
     return modState


case 'FLYMYRESERVATIONS_PRIMARY_SVMCI':
      //we donot wabt tp save in tsakercuder reviewreducer_cosmose saves it as savetpp aka submit needs teh vales
   
       console.log('sv FLYMYRESERVATIONS_PRIMARY_SVMCI reducer - got action:')
       console.log(action)
       console.log(action.payload.my_data_svmci);
        nsvmci = {}
       if(action.payload.my_data_flyaddress){
         nsvmci = action.payload.my_data_svmci
         modState =  Object.assign({}, state, {
           camciformepData:nsvmci
         
         })
       }
        console.log(modState)
        return modState

        
case 'FLYMYRESERVATIONS_PRIMARY_SVDOC':
    console.log('sv taskreducer gtot action FLYMYRESERVATIONS_PRIMARY_SVDOC  2499reducer - got action:')
    console.log(action)
    console.log(action.payload.my_data_svdoc);
     nsvdoc = {}
    if(action.payload.my_data_flyaddress){
      nsvdoc = action.payload.my_data_svdoc
      modState =  Object.assign({}, state, {
        cadocformepData:nsvdoc
      
      })
    }
     console.log(modState)
     return modState
case 'FLYMYRESERVATIONS_PRIMARY_SVTOC':
      console.log('sv taskreducer  2512 gtot action FLYMYRESERVATIONS_PRIMARY_SVTOC  2499reducer - got action:')
      console.log(action)
      console.log(action.payload.my_data_svtoc);
       nsvtoc = {}
      if(action.payload.my_data_flyaddress){
        nsvtoc = action.payload.my_data_svtoc
        modState =  Object.assign({}, state, {
          cadocformepData:nsvtoc
        
        })
      }
       console.log(modState)
       return modState
case 'FLYMYRESERVATIONS_PRIMARY_ADDRESS':
    console.log("rTASKREDUCER MODIFYING FORM fpdData %%%%%%%%we got action FLYMYRESERVATIONS_PRIMARY_ADDRESS  success*****************");
    console.log(action.payload.my_data_flyaddress);
    let nFlyAddress = {}
    if(action.payload.my_data_flyaddress){
      nFlyAddress = action.payload.my_data_flyaddress
      modState =  Object.assign({}, state, {
        fpdData:nFlyAddress
      
      })
    }
    // let januState = {...state, loading: false, my_data: action.payload.my_data}
    //januState = {...state,  my_data_flyaddress: action.payload.my_data_flyaddress}
    //return januState

  
return modState

case 'FLYMYRESERVATIONS_PRIMARY_CARD':
      console.log("rTASKREDUCER MODIFYING FORM fpdData %%%%%%%%we got action FLYMYRESERVATIONS_PRIMARY_CARD  success*****************");
      console.log(action.payload.my_data_card);
        let nFlyCard = {}
        if(action.payload.my_data_card){
          nFlyCard = action.payload.my_data_card
          modState =  Object.assign({}, state, {
            fpcData:nFlyCard
          
          })
        }
        // let januState = {...state, loading: false, my_data: action.payload.my_data}
        //januState = {...state,  my_data_flyaddress: action.payload.my_data_flyaddress}
        //return januState

      
   return modState
   //svmay21
   case 'SOJMYRESERVATIONS_D_TOKEN':
    console.log("rTASKREDUCER MODIFYING  SOJMYRESERVATIONS_D_TOKEN FORM vpcData %%%%%%%%we got action FLYMYRESERVATIONS_PRIMARY_CARD  success*****************");
    console.log(action.payload.my_data_dtoken);
      let nSoj = {}
      if(action.payload.my_data_dtoken){
        nSoj = action.payload.my_data_dtoken
        modState =  Object.assign({}, state, {
          sjsjcData:nSoj
        
        })
      }
      // let januState = {...state, loading: false, my_data: action.payload.my_data}
      //januState = {...state,  my_data_flyaddress: action.payload.my_data_flyaddress}
      //return januState

    
 return modState 
  //SVF5 start
  case 'FLYMYRESERVATIONS_D_TOKEN':
      console.log("rTASKREDUCER MODIFYING  FLYMYRESERVATIONS_D_TOKEN FORM vpcData %%%%%%%%we got action FLYMYRESERVATIONS_PRIMARY_CARD  success*****************");
      console.log(action.payload.my_data_dtoken);
        let nFlyDtoken = {}
        if(action.payload.my_data_dtoken){
          nFlyDtoken = action.payload.my_data_dtoken
          modState =  Object.assign({}, state, {
            vpcData:nFlyDtoken
          
          })
        }
        // let januState = {...state, loading: false, my_data: action.payload.my_data}
        //januState = {...state,  my_data_flyaddress: action.payload.my_data_flyaddress}
        //return januState

      
   return modState
  //svf5 end
   case 'FLYMYRESERVATIONS_PRIMARY_SVDOC':
    console.log("rTASKREDUCER 2545 **MODIFYING FORM FLYMYRESERVATIONS_PRIMARY_SVDOC fpdData %%%%%%%%we got action FLYMYRESERVATIONS_PRIMARY_CARD  success*****************");
    console.log(action.payload.my_data_svdoc);
       nsvdoc = {}
      if(action.payload.my_data_svdoc){
        nsvdoc = action.payload.my_data_svdoc
        modState =  Object.assign({}, state, {
          cadocformepData:nsvdoc
        
        })
      }
      // let januState = {...state, loading: false, my_data: action.payload.my_data}
      //januState = {...state,  my_data_flyaddress: action.payload.my_data_flyaddress}
      //return januState

    
 return modState

case "task/CREATE_STEP":
 console.log('create stepform reducer')
   id = action.payload.my_account_data.id
    if(id &&  (typeof(id)== 'number') ){
       //we are good
      }else{
        id =  parseInt(id)
      }

      //sv step for id > -1 do fectch or call task/GET_TASK
     let nStep = {
       id:-1,
        // used to populate "account" reducer when "Load" is clicked
        firstName: 'Jane',
        lastName: 'Doe',
        age: '42',
        sex: 'female',
        employed: true,
        favoriteColor: 'Blue',
        bio: 'Born to write amazing Redux code.'
      }
      
      if(action.payload.my_account_data){
        nStep = action.payload.my_account_data
      }

	let nTask =	{
		 "id":-1,
		"name":"",
		"description":"",
		"configSchema":"<pdfTaskNew></pdfTaskNew>",
		"endpoints":[{
			"url":"execute1",
			"inputSchema":"",
			"outputSchema":""
		
		}]
	}
/*
	let nTask =  {
                name:'',
                description:'',
                configSchema:''
            },
            value: `{
                "name": "sv",
                "modettt": "sv"
            }`,
      theme: 'github',
      mode: 'json',
      enableBasicAutocompletion: false,
      enableLiveAutocompletion: false,
      fontSize: 14,
      showGutter: true,
      showPrintMargin: true,
      highlightActiveLine: true,
      enableSnippets: false,
      showLineNumbers: true
        }*/
      if(id < 0){   
      }

     modState =  Object.assign({}, state, {
     	stepData:nStep
       
      })
    return modState


    break


	case GET_EP:
		console.log('reducere ep')

       let taskId = action.id
       console.log(taskId)
       let svns = _.clone(state)
       svns.movies.endpoints = []
       let task = null
       if(state.tasks){
         task =state.tasks.find( function(o, i){
              console.log(o.id + ':' + taskId)
              return(o.id ===  taskId)
          } )

       }
       console.log('fount task');
       console.log(task)
     state.endpoints = _.clone(task.endpoints) 

     console.log(svns)
     

       return state
case "task/CREATE_ACTION":
 console.log('create taskform reducer')
  id = action.id
    if(id &&  (typeof(id)== 'number') ){
        id =action.id
      }else{
        id =  parseInt(action.id)
      }

      //sv step for id > -1 do fectch or call task/GET_TASK

	 nTask =	{
		 "id":-1,
		"name":"",
		"description":"",
		"configSchema":"<pdfTaskNew></pdfTaskNew>",
		"endpoints":[{
			"url":"execute1",
			"inputSchema":"",
			"outputSchema":""
		
		}]
	}
/*
	let nTask =  {
                name:'',
                description:'',
                configSchema:''
            },
            value: `{
                "name": "sv",
                "modettt": "sv"
            }`,
      theme: 'github',
      mode: 'json',
      enableBasicAutocompletion: false,
      enableLiveAutocompletion: false,
      fontSize: 14,
      showGutter: true,
      showPrintMargin: true,
      highlightActiveLine: true,
      enableSnippets: false,
      showLineNumbers: true
        }*/
      if(id < 0){   
      }

     modState =  Object.assign({}, state, {
        task:nTask,
        teditor: {
          value: `{
               "name": "sv",
               "modettt": "sv"
           }`,
         theme: 'github',
         mode: 'json',
         enableBasicAutocompletion: false,
         enableLiveAutocompletion: false,
         fontSize: 14,
         showGutter: true,
         showPrintMargin: true,
         highlightActiveLine: true,
         enableSnippets: false,
         showLineNumbers: true
      
       }
      })
    return modState


    break

	case  "task/GET_TASK" :
		 console.log('task reducer')
      console.log(state)
      console.log(action)
       id =  parseInt(action.idx)
       svns = {...state}
       tasks = state.tasks
       arfound = tasks.find(function(o,i){
         console.log(o)
          found = false

         if(o.id  === id){
          found = true
         }
         return found

      } )

     console.log(arfound)
     state.task = _.cloneDeep(arfound)

     var nState2= Object.assign({}, state, {task:arfound})
     return nState2
    case  DELETE_TASK :
		 console.log('task reducer--deletetask')
      console.log(state)
      console.log(action)
      if(id &&  (typeof(id)== 'number') ){
        id =action.id
      }else{
        id =  parseInt(action.idx)
      }
     
       svns = {...state}
       tasks = state.tasks
     let nowTasks = _.filter(tasks, function(o, idx){
        return (o.id !=id)
      })
       arfound = tasks.find(function(o,i){
         console.log(o)
          found = false

         if(o.id  != id){
          found = true
         }
         return found

      } )

     console.log(arfound)
     var nState = Object.assign({}, state, {
      tasks: nowTasks
    })

     state.tasks = _.cloneDeep(nowTasks)
     
     svns = {...state}
     console.log(nState)
     return nState
 case FETCH_MOVIES:
   svns = {...state, all:action.movies}
  console.log('FETCH_MOVIES')
  console.log(svns)
  return svns


 case FETCH_MOVIE:
   svns = {...state, current:this.state.all[action.index -1]}
  console.log('FETCH_MOVIES')
   console.log(svns)
  return svns

default:
return state

	}
 }


 export default SVTasksReducer
